import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-right",
  "use": "arrow-right-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-right\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13 4.58594L20.4142 12.0002L13 19.4144L11.5858 18.0002L16.5858 13.0002H3.5V11.0002H16.5858L11.5858 6.00015L13 4.58594Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol